import {MatPaginatorIntl} from '@angular/material/paginator';
import {Injectable} from '@angular/core';

@Injectable()
export class MatPaginatorIntPtBr extends MatPaginatorIntl {
    itemsPerPageLabel = 'Itens por página';
    nextPageLabel     = 'Próxima';
    previousPageLabel = 'Anterior';

    getRangeLabel = (page: number, pageSize: number, length: number) => {
        return ((page * pageSize) + 1) + ' - ' + ((page * pageSize) + pageSize) + ' de ' + length;
    }
}
